import dayjs from 'dayjs'
import { Camp } from '@/GeneratedTypes/Camp'
export function setKeyDatesForNewCamp(camp: Camp) {
  if (!camp.upwardLeagueID) {
    camp.registrationBeginDate = dayjs().toDate()
    camp.campStartDate = dayjs().add(16, 'week').toDate()
  }
}
